export const makeQueryString = (params: { [key: string]: string | undefined }): string =>
  Object.keys(params)
    .filter((key) => params[key] !== undefined)
    .map((key) => key + "=" + encodeURIComponent(params[key]!))
    .join("&");
